import { Navigate, useLocation } from 'react-router-dom';
import { cheminConnexion } from '../utils/redirectionConnexion';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading while verifying authentication
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: '#f8f9fa',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>⏳</div>
          <div style={{ fontSize: '18px', color: '#666' }}>Vérification...</div>
        </div>
      </div>
    );
  }

  // Non connecté : la racine mène à la page publique, toute autre page à la connexion
  // en mémorisant la destination (lien d'e-mail vers une fiche valeur, par exemple).
  if (!isAuthenticated) {
    return <Navigate to={cheminConnexion(location.pathname, location.search)} replace />;
  }

  return children;
};

export default ProtectedRoute;
